import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CheckboxInput } from '@calendly/ui/components/checkbox-input'
import { Popup } from '@calendly/ui/components/popup'
import classNames from 'classnames'
import { useState } from 'react'

import {
  inlineCallieOptionCss,
  inlineCheckboxCss,
  inlineEyebrowCss,
  inlineLinkCheckboxCss,
  inlineLinkOptionCopyCss,
  inlineLinkOptionCss,
  inlineOptionCopyCss,
  inlineOptionCss,
  inlineOptionDescriptionCss,
  inlineOptionDisabledCss,
  inlineOptionHeadingCss,
  inlineOptionLabelCss,
  inlineOptionsCss,
  inlinePanelCss,
  inlinePanelFooterCss,
  inlinePanelHeaderCss,
  inlineTitleCss,
  optInButtonCss,
  recommendedBadgeCss
} from './styles'
import type { ExperienceProps } from './types'
import { VariantIcon } from './variant_icon'

export const MultiSelectEntryPoint = ({ isLoading, onSave }: ExperienceProps) => {
  const [isCallieSelected, setIsCallieSelected] = useState(true)
  const [isLinkSelected, setIsLinkSelected] = useState(true)
  const canContinue = isCallieSelected || isLinkSelected

  return (
    <Popup isBlocking onClose={() => {}} size="max-content">
      <section
        aria-labelledby="callie-multi-select-title"
        className={inlinePanelCss}
        data-testid="callie-multi-select-entry-point"
      >
        <header className={inlinePanelHeaderCss}>
          <p className={inlineEyebrowCss}>
            {I18n.t('publisher.growth_experiments.callie_intro_entry_points.eyebrow')}
          </p>
          <h2 className={inlineTitleCss} id="callie-multi-select-title">
            {I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.title')}
          </h2>
        </header>
        <div className={inlineOptionsCss}>
          <label
            className={classNames(inlineOptionCss, inlineCallieOptionCss, {
              [inlineOptionDisabledCss]: isLoading
            })}
          >
            <VariantIcon isCallie />
            <span className={inlineOptionCopyCss}>
              <span className={inlineOptionHeadingCss}>
                <span className={inlineOptionLabelCss}>
                  {I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.ai_label')}
                </span>
                <span className={recommendedBadgeCss}>
                  {I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.recommended')}
                </span>
              </span>
              <span className={inlineOptionDescriptionCss}>
                {I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.ai_description')}
              </span>
            </span>
            <span className={inlineCheckboxCss}>
              <CheckboxInput
                aria-label={I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.ai_label')}
                checked={isCallieSelected}
                disabled={isLoading}
                onChange={(event) => setIsCallieSelected(event.currentTarget.checked)}
              />
            </span>
          </label>
          <label
            className={classNames(inlineOptionCss, inlineLinkOptionCss, {
              [inlineOptionDisabledCss]: isLoading
            })}
          >
            <VariantIcon isCallie={false} />
            <span className={classNames(inlineOptionCopyCss, inlineLinkOptionCopyCss)}>
              <span className={inlineOptionLabelCss}>
                {I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.link_label')}
              </span>
              <span className={inlineOptionDescriptionCss}>
                {I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.link_description')}
              </span>
            </span>
            <span className={classNames(inlineCheckboxCss, inlineLinkCheckboxCss)}>
              <CheckboxInput
                aria-label={I18n.t('publisher.growth_experiments.callie_intro_entry_points.multi_select.link_label')}
                checked={isLinkSelected}
                disabled={isLoading}
                onChange={(event) => setIsLinkSelected(event.currentTarget.checked)}
              />
            </span>
          </label>
        </div>
        <footer className={inlinePanelFooterCss}>
          <Button
            className={optInButtonCss}
            data-testid="callie-primary-action"
            disabled={!canContinue || isLoading}
            loading={isLoading}
            onClick={() => onSave({
              response: isCallieSelected ? 'opted_in' : 'opted_out',
              schedulingLinkSelected: isLinkSelected
            }, isCallieSelected)}
          >
            {I18n.t('publisher.growth_experiments.callie_intro_entry_points.continue')}
          </Button>
        </footer>
      </section>
    </Popup>
  )
}
